module.exports = __webpack_public_path__ + "img/emoji-mashup-bot.527b4281.png";